import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, AlertCircle } from 'lucide-react';
import AdminLayout from '../../../components/admin/AdminLayout';

const CollectionReportsPage = () => {
  const navigate = useNavigate();

  const agingData = [
    { range: '0-30 يوم', amount: 15000, count: 3 },
    { range: '31-60 يوم', amount: 25000, count: 5 },
    { range: '61-90 يوم', amount: 10000, count: 2 },
    { range: 'أكثر من 90 يوم', amount: 9500, count: 2 }
  ];

  const totalDue = agingData.reduce((sum, d) => sum + d.amount, 0);
  const collectionRate = 85;

  return (
    <AdminLayout>
      <div className="p-6 max-w-7xl mx-auto">
        <button onClick={() => navigate('/admin/finance/reports')} className="inline-flex items-center gap-2 text-gray-600 hover:text-[#1E3A8A] mb-4 transition-colors">
          <ArrowRight className="w-5 h-5" /><span className="font-semibold">العودة للتقارير</span>
        </button>
        <h1 className="text-3xl font-black text-[#1E3A8A] mb-6 flex items-center gap-3">
          <AlertCircle className="w-8 h-8" /><span>تقارير التحصيل والذمم</span>
        </h1>

        <div className="grid grid-cols-2 gap-4 mb-6">
          <div className="bg-white rounded-lg shadow-sm border-2 border-orange-200 p-4">
            <p className="text-sm text-gray-600 mb-1">إجمالي الذمم المدينة</p>
            <p className="text-3xl font-black text-orange-600">{totalDue.toLocaleString()} ر.س</p>
          </div>
          <div className="bg-white rounded-lg shadow-sm border-2 border-green-200 p-4">
            <p className="text-sm text-gray-600 mb-1">نسبة التحصيل</p>
            <p className="text-3xl font-black text-green-600">{collectionRate}%</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border-2 border-gray-200 overflow-hidden mb-6">
          <div className="bg-gray-50 border-b-2 border-gray-200 px-4 py-3">
            <h3 className="font-black text-gray-800">تقرير أعمار الديون (Aging Report)</h3>
          </div>
          <table className="w-full">
            <thead className="bg-gray-50 border-b-2 border-gray-200">
              <tr>
                <th className="px-4 py-3 text-right text-sm font-bold text-gray-700">الفترة</th>
                <th className="px-4 py-3 text-center text-sm font-bold text-gray-700">عدد الفواتير</th>
                <th className="px-4 py-3 text-right text-sm font-bold text-gray-700">المبلغ</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {agingData.map((d, i) => (
                <tr key={i} className="hover:bg-gray-50">
                  <td className="px-4 py-3 font-semibold">{d.range}</td>
                  <td className="px-4 py-3 text-center">{d.count}</td>
                  <td className="px-4 py-3 text-orange-600 font-black text-lg">{d.amount.toLocaleString()} ر.س</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
};

export default CollectionReportsPage;